import React from 'react';
import {
  Box,
  Typography,
  Container,
  Alert,
  Button,
  Card,
  CardContent
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const VerifyEmailPrompt = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'background.default',
        py: 12,
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Card
          elevation={0}
          sx={{
            borderRadius: 2,
            border: 1,
            borderColor: 'divider',
          }}
        >
          <CardContent
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              p: 4,
              gap: 3
            }}
          >
            <Typography
              component="h1"
              variant="h4"
              gutterBottom
              sx={{
                color: 'primary.main',
                fontWeight: 500,
              }}
            >
              Email Verification Required
            </Typography>

            <Alert severity="info" sx={{ width: '100%' }}>
              <Typography variant="body1" gutterBottom>
                Please verify your email address to continue. We've sent a verification link to your email.
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Check your inbox and spam folder. Click the link in the email to verify your account.
              </Typography>
            </Alert>

            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
              <Button
                variant="outlined"
                onClick={handleLogout}
              >
                Back to Login
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default VerifyEmailPrompt; 